<script setup lang="ts">
import PartsCombination from '@/components/propertyTaxUpload/PartsCombination.vue'
</script>

<template>
  <div class="property-tax-upload">
    <PartsCombination></PartsCombination>
  </div>
</template>

<style lang="scss" scoped>
.property-tax-upload {
  margin: 1.5% 3%;
}
</style>
